import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-ag-button-set',
  templateUrl: './ag-button-set.component.html',
  styleUrls: ['./ag-button-set.component.scss'],
})
export class AgButtonSetComponent {
  @Input() primaryShow = true;
  @Input() primaryDisabled = false;
  @Input() backDisabled = false;
  @Input() primaryLabel = '';
  @Input() secondaryShow = true;
  @Input() tertiaryDisabled = false;
  @Input() tertiaryLabel = '';
  @Input() tertiaryShow = true;

  @Output() backButton = new EventEmitter();
  @Output() cancelButton = new EventEmitter();
  @Output() continueButton = new EventEmitter();

  backButtonFunction(): void {
    this.backButton.emit();
  }

  cancelButtonFunction(): void {
    this.cancelButton.emit();
  }

  continueButtonFunction(): void {
    this.continueButton.emit();
  }
}
